/*
 * @Author: Merlin
 * @Date: 2023-12-18 14:51:29
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-29 17:34:24
 */
import { asyncEmit } from '@/utils/socket';
import {
    ActionInt,
    type GameResultType, 
} from '@/pages/casino/redpacketGame/ts/redPacketCommon';


export const useRedPacket = (rootPath='games') => {
    const prefix = `${rootPath}.redpacket`; 
    
    // 开始接收游戏广播：红包数量 
    const ON_REDPACKET_BROADCAST = (
        callback: (res) => any,
    ) => {
        const sChannel = `${prefix}.info`;
        // asyncEmit(sChannel, {});
        // return ()=> void 0;
        socket.on(sChannel, callback);
        return () => {
            // import.meta.dev && console.log('Channel closed:', sChannel);
            socket.off(sChannel, callback); 
        };
    };

    // 开始接收游戏广播：玩家信息 
    const ON_REDPACKET_PLAYER_INFO = (
        callback: (res) => any,
    ) => {
        const sChannel = `${prefix}.marquee`;
        // asyncEmit(sChannel, {});
        // return ()=> void 0;
        socket.on(sChannel, callback);
        return () => {
            // import.meta.dev && console.log('Channel closed:', sChannel);
            socket.off(sChannel, callback); 
        };
    };
    // 开始接收游戏广播：玩家连杀事件 
    const ON_REDPACKET_PLAYER_DEEDS = ( 
        callback: (res) => any,
    ) => {
        const sChannel = `${prefix}.combo`;
        // asyncEmit(sChannel, {});
        // return ()=> void 0;
        socket.on(sChannel, callback);
        return () => {
            // import.meta.dev && console.log('Channel closed:', sChannel);
            socket.off(sChannel, callback); 
        };
    };

    // 取消接收游戏广播 
    const EMIT_REDPACKET_LEAVE = async () => {
        const sApi = `${prefix}.exit`;
        const res = await asyncEmit(sApi, {});
        return res;
    };

    // 下注（收/发红包）
    const EMIT_REDPACKET_BET = async ( 
        oParams,
    ) => {
        const sApi = `${prefix}.bet`;
        const res = await asyncEmit<GameResultType>(
            sApi,
            oParams,
        );
        return res;
    };

    // ↓ 查询当前房间的用户在线列表 
    const EMIT_GET_REDPACKET_ROOM_PLAYERS = async () => {
        const sApi = `${prefix}.onlineList`;
        const res = await asyncEmit(
            sApi,
            {},
        );
        return res;
    }

    
    // ===============================================
    //   ↑ 下注操作相关 
    //   ↓ 历史相关
    // ===============================================

    // ↓ 查询历史列表 
    const EMIT_GET_REDPACKET_HISTORY = async (
        oParams: {
            action: ActionInt;
            "page": Number; 
            "page_size": Number;
        },
    ) => {
        const sApi = `${prefix}.getHistory`;
        const res = await asyncEmit(
            sApi,
            oParams,
        );
        return res;
    }

    // ↓ 查询历史详情
    const EMIT_GET_REDPACKET_DETAIL = async (
        oParams,
        fnCallback,
    ) => {
        const sApi = `${prefix}.getHistoryDetail`;
        const res = await asyncEmit(
            sApi,
            {...oParams},
        );
        if (fnCallback){
            fnCallback(res);
        }
        return res;
    }

    return {
        EMIT_GET_REDPACKET_HISTORY,
        EMIT_GET_REDPACKET_DETAIL,
        EMIT_GET_REDPACKET_ROOM_PLAYERS,
        EMIT_REDPACKET_BET, 
        EMIT_REDPACKET_LEAVE,
        ON_REDPACKET_BROADCAST,
        ON_REDPACKET_PLAYER_INFO,
        ON_REDPACKET_PLAYER_DEEDS,
    };
};





